// src/components/ItemCardSingleModal/ItemCardSingle.jsx
import { useState, useEffect } from "react";
import ItemModal from "../SearchModal/ItemModal";
import MySwiper from "../SearchModal/MySwiper";
import ItemModalBody from "../ItemModalBody";
import { trackButtonClick } from "../../utils/ItemCardClickedAnalytics"; // 追加

const ItemCardSingle = ({ item }) => {
 //  const [isOpen, setIsOpen] = useState(true);
 const [isOpen, setIsOpen] = useState(false);

 useEffect(() => {
  // データ取得後にモーダルを開く
  if (item) {
   // イベントをトラッキング
   trackButtonClick(item.item_inhouse_code, item.item_number, item.item_color_en);
   setIsOpen(true);
  }
 }, [item]);

 if (!item) {
  // console.error("Item data is missing");
  return null;
 }

 const getPrefixWidth = (width) => {
  switch (width) {
   case "2E":
    return "（標準）";
   case "3E":
    return "（ややゆったり）";
   case "4E":
   case "5E":
    return "（ゆったり）";
   default:
    return "";
  }
 };

 const url = `https://kutsu.com/item/${item.item_inhouse_code}.html`;

 const item_size_min_max = (() => {
  const sizeArray = item.item_size.split(",");
  const minSize = sizeArray[0].replace("cm", "");
  const maxSize = sizeArray[sizeArray.length - 1];
  return minSize + "〜" + maxSize;
 })(item.item_size);

 const formattedPrice = (item_price) => Number(item_price).toLocaleString();

 useEffect(() => {
  const elBody = document.getElementsByTagName("body")[0];
  let scrollpos;

  if (!isOpen) return;

  scrollpos = window.scrollY;
  elBody.style.top = scrollpos * -1 + "px";
  elBody.style.position = "static";

  return () => {
   elBody.style.top = "";
   elBody.style.position = "";
   window.scrollTo(0, scrollpos);
  };
 }, [isOpen]);

 return (
  <>
   <ItemModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
    <MySwiper
     value={{
      item_inhouse_code: item.item_inhouse_code,
      item_number: item.item_number,
      item_color_en: item.item_color_en,
      item_total_images_2: item.item_total_images_2,
      item_total_images_3: item.item_total_images_3,
      item_total_video: item.item_total_video,
     }}
    />
    <ItemModalBody item={item} item_size_min_max={item_size_min_max} formattedPrice={formattedPrice} url={url} getPrefixWidth={getPrefixWidth} className="--card-single" />
   </ItemModal>
  </>
 );
};

export default ItemCardSingle;
